import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { Employee } from '../../../api/models/employee.model'

@Injectable({ providedIn: 'root' })
export class EmployeeFilterService {
    employeeSubject = new Subject<Employee | undefined>()
    employee$ = this.employeeSubject.asObservable()
    lastSelectedEmployee?: Employee

    setEmployee(employee?: Employee): void {
        this.lastSelectedEmployee = employee
        this.employeeSubject.next(employee)
    }
}
